import type { ReactNode } from 'react';
import React from 'react';

interface BaseRowProps {
    children: ReactNode;
}

function BaseRow({ children }: BaseRowProps) {
    return (
        <tr className="border-b align-baseline odd:bg-white even:bg-gray-50">
            {React.Children.map(children, (child) => (
                <td className="px-6 py-4">{child}</td>
            ))}
        </tr>
    );
}

export default BaseRow;
